import React from 'react';
import classnames from 'classnames';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import s from './MiniProfileIdentity.scss';
import { PapiUser } from '@wix/da-types-papi';

export interface Props {
  user: PapiUser;
  className?: string;
  usernameClassName?: string;
  withTooltip?: boolean;
}

class MiniProfileIdentity extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    withTooltip: true,
  };
  render() {
    const props = this.props;
    return (
      <div className={classnames(s['root'], props.className)}>
        <UserLink
          user={props.user}
          className={s['content-wrapper']}
          contentClassName={s['content']}
          withTooltip={props.withTooltip}
        >
          <UserAvatar
            user={props.user}
            className={s['user-avatar']}
            withLink={false}
            withTooltip={false}
          />
          <span className={classnames(s['user-name'], props.usernameClassName)}>
            {props.user.username}
          </span>
        </UserLink>
      </div>
    );
  }
}

export default MiniProfileIdentity;
